<template>
    <div class="inp-s-wrap full" :class="{ '--icon': isEdit || isValidate || isClearBtn, active: showLabel, 'inp-disabled': disabled, '--error': isError, 'repeat-error':  repeatError}">
        <span class="inp-s-label" :class="{ error: isError, 'repeat-error':  repeatError }">{{ placeholder }}</span>

        <input :type="type"
            ref="field"
            :id="inputId"
            @keyup.enter="enter()"
            @focus="setFocus(true)"
            @blur="setFocus(false)"
            @keyup.ctrl.90="clearName"
            class="inp-s"
            :placeholder="placeholderInput"
            :class="[{ error: isError, disabled:disabled, 'repeat-error': repeatError }, classBtn]"
            :disabled="disabled"
            :value="value"
            v-mask="mask"
            :name="nameInput"
            @input="updateValue($event.target.value)"
            @keyup="checkCounterError()"
            :maxlength="(maxLengthNum)?maxLengthNum:(maxLength)?maxLength:''"
            :autocomplete="fieldAutocomplete"
        >

        <span class="field-clear__btn" v-if="isClearBtn" @click="clear" >
            <span class="i i-close2"></span>
        </span>

        <span class="inp-s-error" v-if="isError && !(errorText === 'Обязательное поле' && value.toString().length > 0)">{{ errorText }}</span>

        <span class="inp-s-icon">
            <span class="i i-pencil2 --edit" v-if="isEdit" @click="edit"></span>
            <span class="i i-ok2" v-if="isValidate" @click="check"></span>
            <span class="i i-info3" v-if="isError"></span>
        </span>

        <span class="inp-s-counter" v-if="maxLengthNum" :class="{'counter-error':  maxLengthNum - value.length  == 0, 'repeat-error': repeatCounterError }">{{ maxLengthNum - value.length }}</span>
    </div>
</template>

<script>
    import {number_format} from '@/helpers/formatted.js';

    export default {
        name: "InputStyled",
        props: {
            value: {default: ''},
            placeholder: {default: ''},
            placeholderInput: {default: ''},
            inputId: {default: ''},
            disabled: {default: false},
            classBtn: {default: ''},
            isError: {default: false},
            isEdit: {default: false},
            isBlockArrowPhone: {default: false},
            isMoney: {default: false},
            maxMoney: {default: 9999999},
            isValidate: {default: false},
            errorText: {default: ''},
            mask: {default: ''},
            name: {default: 'name'},
            isClearBtn: {default: false},
            maxLength: {default: false},
            maxLengthNum: {default: ''},
            fieldAutocomplete: {default: 'off'},
            type: {default:'text'},
            autoFocus: {default: false},
        },
        data: function () {
            return {
                focus: false,
                showPlaceholder: false,
                nameInput: '',
                repeatError: false,
                repeatCounterError: false,
                counterError: false,
            }
        },
        mounted(){
            if(this.name !== 'name'){
                this.nameInput = this.name;
            } else {
                this.nameInput = Math.random().toString(36).substr(2, 5);
            }
            if(this.isBlockArrowPhone) {
                this.$refs.field.addEventListener("keydown", this.blockArrow, false);
            }
            if(this.autoFocus === true) {
                this.inputFocus('field');
            }
        },
        beforeDestroy() {
            this.$refs.field.removeEventListener('keydown', this.blockArrow);
        },
        computed: {
            showLabel() {
                return this.focus || this.value.toString().length > 0;
            },
        },
        watch:{
            isError(val,oldVal){
                if(oldVal){
                    this.repeatError = true;
                }
                if(this.isError){
                    if(this.$el.closest('.popup-wrapper')){
                        let $top = 0;
                        let pr = this.$el.closest('.popup-wrapper');
                        $top += parseFloat(pr.offsetTop);
                        pr.scrollTo({top: $top, left: 0, behavior: 'smooth'});
                    }
                }
            },
            counterError(val, oldVal){
            },
        },
        methods: {
            checkCounterError(){
                this.repeatCounterError = false;
                if(this.counterError && this.maxLengthNum - this.value.length  == 0){
                    setTimeout(() => {
                        this.repeatCounterError = true;
                    }, 10);
                }else{
                    this.repeatCounterError = false;
                    if(this.maxLengthNum - this.value.length  == 0){
                        this.counterError = true;
                    }else{
                        this.counterError = false;
                    }
                }
            },
            clearName(){
                if(this.name === 'nameCompany'){
                    let val = this.$refs.field.value.replace(/«/g,'').replace(/»/g,'');
                    this.$refs.field.value = val
                    this.$emit('input', val);
                }
            },
            blockArrow(e){
                if ((e.keyCode >= 37 && e.keyCode <= 40)) {
                    e.preventDefault();
                    return false;
                }
            },
            updateValue: function (value) {
                let v = value;
                if(this.isMoney) {
                    v = v.replace(/[-;":'a-zA-Zа-яА-Я\\=`ё/\*++!@#$%\^&_№?><\s]/g, "");
                    if(+v > this.maxMoney) {
                        v = this.maxMoney;
                        v = number_format(v, 0, '', ' ')

                    } else {
                        if(v !== ''){
                            v = number_format(v, 0, '', ' ')
                        }

                    }
                    this.$refs.field.value = v
                }
                if(this.mask && this.mask.mask == '9{1,2}%'){
                    if(+v !== 0){
                        v = +v;
                        this.$refs.field.value = v
                    }
                }
                this.$emit('input', v);
            },
            enter: function () {
                this.$emit('enter');
            },
            check: function () {
                this.$emit('check')
            },
            clear: function() {
                this.$refs.field.focus();
                this.$emit('input', '');
            },
            setFocus(value) {
                let self = this
                value = value || false;
                this.focus = value;
                this.repeatError = false;
                if(value){
                    this.$emit('focus');
                    setTimeout(function () {
                        self.showPlaceholder = true;
                    }, 50);
                } else {
                    this.$emit('blur');
                    this.showPlaceholder = false;
                }
            },
            edit: function () {
                this.$emit('edit');
            },
            inputFocus(ref) {
                if(!!this.$refs[ref]){
                    this.$nextTick(() => {this.$refs[ref].focus()});
                }
            },

        }
    }
</script>

<style>

</style>
